import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { contentfulViews, components } from '@glowforge/ui-common';
import features from 'app/common/containers/features';

import './no-glowforge.less';

const { ButtonLink, TextSection } = contentfulViews;
const { Markdown } = components;

function NoGlowforge(props) {
  return (
    <div className='NoGlowforge contentPage'>
      <div className='content'>
        <Markdown source={_.get(props.title, 'text')} />
        <div className='cols fullWidth'>
          <div className='arrived'>
            <TextSection {...props.arrivedSection} headerClass='h4' />
            <ButtonLink {...props.beginSetupButton} />
          </div>
          <TextSection {...props.notArrivedSection} headerClass='h4' />
          <TextSection {...props.addSomeonesSection} headerClass='h4' />
          <TextSection {...props.haventPurchasedSection} headerClass='h4' />
        </div>
      </div>
    </div>
  );
}

NoGlowforge.propTypes = {
  title: PropTypes.string.isRequired,
  arrivedSection: TextSection.propTypes.isRequired,
  beginSetupButton: ButtonLink.propTypes.isRequired,
  notArrivedSection: TextSection.propTypes.isRequired,
  addSomeonesSection: TextSection.propTypes.isRequired,
  haventPurchasedSection: TextSection.propTypes.isRequired,

};

NoGlowforge.defaultProps = {
  content: null,
};

export default features(NoGlowforge);



// WEBPACK FOOTER //
// ./app/components/no-glowforge.jsx